import React from "react";
import { Navigate } from "react-router-dom";
import { normalizeRole } from "../../utils/roleMap";
import { clearStoredAuth, isJwtExpired } from "../../utils/authSession";

const roleHome = {
  admin: "/dashboard/admin",
  applicant: "/dashboard/applicant",
  employer: "/dashboard/employer",
  press: "/dashboard/press",
};

const RoleGate = ({ allow = [], children }) => {
  const token = localStorage.getItem("token");
  const role = normalizeRole(localStorage.getItem("role"));

  if (!token || !role) {
    return <Navigate to="/login" replace />;
  }

  if (isJwtExpired(token)) {
    clearStoredAuth();
    return <Navigate to="/login" replace />;
  }

  if (allow.includes(role)) {
    return children;
  }

  return <Navigate to={roleHome[role] || "/login"} replace />;
};

export default RoleGate;
